<template>
    <div class="side-bar">
        <div class="subtitle flex-align-between">
            <h2 class="text f16 flex-align">近期聚焦</h2>
            <!-- <button class="more f12">查看更多 &gt;</button> -->
        </div>
        <ul class="day-lists">
            <li class="flex-align" v-for="(li, index) in lists" :key="index" @click="toPage(li)">
            <div class="day f12 flex-column">
                <!-- <span class="f28">{{handleTime(li.updateTime,'month')}}</span><span>{{handleTime(li.updateTime,'day')}}</span> -->
                <span class="f28">{{dayjs(li.updateTime).format('DD')}}</span><span>{{dayjs(li.updateTime).format('MMM')}}</span>
            </div>
            <div class="describe">
                <h3 class="title wes">{{li.title}}</h3>
                <span class="eye f12">{{li.views || 0}}</span>
            </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
             lists:[{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                lookNum:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                lookNum:'1273'
            },{
                day:'25',
                month:'Apr',
                title:'【要点串烧】理论讲堂-教育信息化2.0教育教育',
                lookNum:'1273'
            }]
        }
    },
    methods:{
        async getFoucsList(){
            
            let resData = await Api.News.GetFocusList();
             console.log(resData);
            this.lists = resData.data;
        },
        handleTime(time,type){
            if (type === 'month') {
                return Common.handleTimeFour(time);
            } else if (type === 'day') {
                return Common.handleTimeThree(time);
            }
        },
        // toPage(id){
        //     Common.goPage(`/news/topic/detail/${id}`,this)
        //  }
         toPage(item){
            let path = ''
            switch(item.clazz) {
                case 1 :
                    path = '/news/headlines/detail/';
                    break
                case 2 :
                    path = '/news/composite/detail/';
                    break
                case 3 :
                    path = '/news/topic/detail/';
                    break  
            }
            Common.goPage( path + item.id, this)
         }
    },
    mounted(){
        this.$nextTick(function(){
            this.getFoucsList();
        })
            
        
    }
}
</script>

<style lang="less" socped>
    .side-bar {
        width: 364px;

        .subtitle {
        padding: 0 22px;
        border-bottom: 1px dashed #004098;
        height: 60px;
        
        color: #1c4b90;

        .text::before {
            content: ' ';
            display: inline-block;
    
            margin-right: 11px;
            width: 20px;
            height: 20px;

            background-image: url("../../../../static/news/recent@2x.png");
        }
    }

        .day-lists {
            padding-top: 38px;
            
            li {
                margin-bottom: 20px;
                cursor: pointer;
            }

            .day {
                position: relative;

                margin-right: 17px;
                padding: 10px 0; 
                width: 66px;

                color: #fff;
                background-color: #54A5D8;
                text-align: center;
                line-height: 1;

                span:first-child {
                    margin-bottom: 6px;
                }

                &::after {
                    content: ' ';
                    
                    position: absolute;
                    right: -6px;
                    top: 6px;

                    width: 6px;
                    height: 54px;

                    background-color: #BEE3FF;
                }
            }

            .describe {
                .title {
                    margin: 0 0 13px 0;
                    max-width: 257px;
                }

                .eye {
                    color: #999;
                }
                .eye::before {
                    content: ' ';
                    display: inline-block;
        
                    margin-right: 4px;
                    width: 16px;
                    height: 12px;
                    background-repeat: no-repeat;
                }

                .eye::before {
                    background-image: url("../../../../static/news/eye@2x.png");
                    background-size: 16px 17px;
                }
            }
        }
        
        .f28 {
        font-size: 28px;
        }
    }
</style>